export function shorten(str: string, maxLength: number): string {
  if (str.length > maxLength) {
    return str.substr(0, maxLength - 3) + '...'
  }
  return str
}

/**
 * Accent-insensitive, case-insensitive string for search / type-ahead matching.
 */
export function normalize(str: string): string {
  try {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
  } catch {
    return str.toLowerCase()
  }
}
